import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Button, message, Tooltip, Select, DatePicker } from "antd";
import moment from "moment";
import { getAgedTicketReasonList, saveDelayedTickets } from "../../../redux/APMS/Tickets/TicketsActions";
import { useSelector } from "react-redux";

const TicketModal = ({ agedTicketModalvisible, setAgedTicketModalvisible, agedTicketData }) => {
    const [data, setData] = useState([]);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [spinStatus, setSpinStatus] = useState(false);

    const { delayedReasonList } = useSelector((state) => state.SDTickets);

    useEffect(async () => {
        await getAgedTicketReasonList();
    }, []);

    useEffect(() => {
        if (agedTicketData) {
            const modifiedData = agedTicketData.map((ticket) => ({
                ...ticket,
                remarks: "",
                reason: "",
            }));
            setData(modifiedData);
        }
    }, [agedTicketData]);

    const handleRemarksChange = (value, record) => {
        const updatedData = data.map((item) =>
            item.id === record.id ? { ...item, remarks: value } : item
        );
        setData(updatedData);
        validateReasons(updatedData);
    };

    const handleReasonChange = (value, record) => {
        const updatedData = data.map((item) =>
            item.id === record.id ? { ...item, reason: value } : item
        );
        setData(updatedData);
        validateReasons(updatedData);
    };

    const handleDueDateChange = (date, dateString, record) => {
        const updatedData = data.map((item) =>
            item.id === record.id ? { ...item, dueDate: dateString } : item
        );
        setData(updatedData);
    };

    const validateReasons = (updatedData) => {
        const allReasonsEntered = updatedData.every(
            (item) => String(item.remarks).trim() !== "" && String(item.reason).trim() !== ""
        );
        setIsSubmitDisabled(!allReasonsEntered);
    };

    const handleReasonSave = async () => {
        try {
            const saveData = data.map((item) => ({
                tktId: item.tktId,
                assignee: item.assigneeId,
                reporter: item.reporterId,
                status: item.statusId,
                dueDate: moment(item.dueDate).format('yyyy-MM-DD'),
                agingDays: item.agingDays,
                reason: item.reason,
                remarks: item.remarks,
                updatedBy: localStorage.getItem("user")
            }));

            setSpinStatus(true);
            var result = await saveDelayedTickets(saveData);
            setSpinStatus(false);

            if (result.result) {
                Modal.success({ title: result.message });
                setAgedTicketModalvisible(false);
            } else {
                Modal.error({ title: result.message });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const columns = [
        {
            title: "Ticket ID",
            dataIndex: "tktId",
            key: "tktId",
            width: 80
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <Tooltip title={text} placement="topLeft">
                    <div>{text?.length > 20 ? `${text.substring(0, 20)}...` : text}</div>
                </Tooltip>
            ),
            width: 100
        },
        {
            title: "Project",
            dataIndex: "prjKey",
            key: "prjKey",
            width: 100
        },
        {
            title: "Reporter",
            dataIndex: "reporter",
            key: "reporter",
            width: 100
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 100
        },
        {
            title: "Priority",
            dataIndex: "priority",
            key: "priority",
            width: 100
        },
        {
            title: "Ticket Type",
            dataIndex: "ticketType",
            key: "ticketType",
            width: 100
        },
        {
            title: "Create Date",
            dataIndex: "createDate",
            key: "createDate",
            render: (text, record) => (
                <div>{moment(text).format('yyyy-MM-DD')}</div>
            ),
            width: 100
        },
        {
            title: "Aging Days",
            dataIndex: "agingDays",
            key: "agingDays",
            width: 80
        },
        {
            title: "Due Date",
            dataIndex: "dueDate",
            key: "dueDate",
            width: 150,
            render: (text, record) => (
                <div>{moment(text).format('yyyy-MM-DD')}</div>
                // <DatePicker
                //     value={text ? moment(text, 'YYYY-MM-DD') : null}
                //     onChange={(date, dateString) => handleDueDateChange(date, dateString, record)}
                //     format="YYYY-MM-DD"
                //     style={{ width: '100%' }}
                //     disabledDate={(current) => current && current < moment().startOf('day')}
                // />
            ),
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            width: 150,
            render: (text, record) => (
                <Select
                    style={{ width: '100%', }}
                    value={text}
                    onChange={(value) => handleReasonChange(value, record)}
                    placeholder="Select a reason"
                    showSearch filterOption={true} optionFilterProp={"children"}
                >
                    {delayedReasonList && [
                        ...delayedReasonList.map((x) => (
                            <Select.Option key={x.id} value={x.id}>{x.reason}</Select.Option>
                        ))
                    ]}
                </Select>
            ),
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
            width: 250,
            render: (text, record) => (
                <Input
                    value={text}
                    onChange={(e) => handleRemarksChange(e.target.value, record)}
                />
            ),
        },
    ];

    return (
        <Modal
            title="Aged Tickets"
            visible={agedTicketModalvisible}
            maskClosable={false}
            closable={false}
            footer={[
                <Tooltip
                    title={isSubmitDisabled ? "Please enter reason and remarks for all tickets" : ""}
                >
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleReasonSave}
                        loading={spinStatus}
                        disabled={isSubmitDisabled}
                    >
                        Submit
                    </Button>
                </Tooltip>
            ]}
            width={1500}
        >
            <Table columns={columns} dataSource={data} rowKey="id" />
        </Modal>
    );
};

export default TicketModal;
